/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationResponseSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  countryCode: z.string(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  holidaySchemeId: z.int().nullish(),
  id: z.int(),
  memberCount: z.int(),
  organizationId: z.string(),
  subdivisionCode: z.string().nullish(),
  type: z.enum(['COUNTRY', 'CUSTOM']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
  workloadSchemeId: z.int().nullish(),
});
